import React from "react"
import Modal from "react-bootstrap/lib/Modal"
import BillingInfo from "../billing_info"
import { Elements, StripeProvider } from "react-stripe-elements"
import { stripeKey } from "../../util/environment_utils"
import PoweredByStripeLogo from "../../images/powered-by-stripe.svg"
import { cardHolderNameIsValid } from "../../util/billing_info_utils"

class PaymentModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            name: "",
            isNameValid: true,
        }
    }

    validateNameField = value => {
        if (value.length > 0) {
            const isNameValid = cardHolderNameIsValid(value)

            this.setState({ isNameValid })
        }
    }

    handleSetName = e => {
        const value = e.target.value

        this.setState({ name: value }, () => {
            this.validateNameField(value)
        })
    }

    togglePaymentModal = () => {
        const { paymentModalOpen, setPaymentModalOpen } = this.props
        setPaymentModalOpen(!paymentModalOpen)
    }

    render() {
        const {
            handleStripeToken,
            paymentPlan,
            teamId,
            customer,
            history,
            teamMembers,
            isLoading,
            handleChangePaymentMethod,
            isUpgrade,
        } = this.props

        const generatePaymentModalTitle = isUpgrade
            ? "Upgrade Now"
            : customer
                ? "Update Credit Card"
                : "Add Credit Card"

        return (
            <Modal
                className="modal-v2 payment-modal-container"
                show={true}
                onHide={this.togglePaymentModal}
            >
                <Modal.Header className="payment-modal-header" closeButton>
                    <Modal.Title>{generatePaymentModalTitle}</Modal.Title>
                    <img
                        src={PoweredByStripeLogo}
                        alt="powered by stripe"
                        width="103"
                        height="17"
                    />
                </Modal.Header>
                <StripeProvider apiKey={stripeKey}>
                    <Elements>
                        <BillingInfo
                            handleStripeToken={handleStripeToken}
                            paymentPlan={paymentPlan}
                            togglePaymentModal={this.togglePaymentModal}
                            teamId={teamId}
                            name={this.state.name}
                            handleSetName={this.handleSetName}
                            isNameValid={this.state.isNameValid}
                            handleChangePaymentMethod={
                                handleChangePaymentMethod
                            }
                            customer={customer}
                            history={history}
                            teamMembers={teamMembers}
                            isLoading={isLoading}
                            isUpgrade={isUpgrade}
                        />
                    </Elements>
                </StripeProvider>
            </Modal>
        )
    }
}

export default PaymentModal



// WEBPACK FOOTER //
// ./src/components/modals/payment_modal.jsx